import styled from "styled-components";
import React from "react";
import { PageContainer, PageTitle } from "../components/Layout.tsx";

const WelcomeCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 3rem;
  box-shadow: 0 2px 8px rgba(0, 31, 82, 0.1);
  text-align: center;
  border-top: 4px solid #64da4c;
  transition: background 0.3s ease, box-shadow 0.3s ease;

  .dark-mode & {
    background: #2a2a3e;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
`;

const Subtitle = styled.p`
  color: #666;
  font-size: 1.1rem;
  transition: color 0.3s ease;

  .dark-mode & {
    color: #b0b0b0;
  }
`;

export default function Home() {
  return (
    <PageContainer>
      <WelcomeCard>
        <PageTitle as="h1">Velkommen</PageTitle>
        <Subtitle>Administrer samtaler og feedback her</Subtitle>
      </WelcomeCard>
    </PageContainer>
  );
}
